const MerchantApprovalFields = [
  {
    fieldId: "vendorConnectionPlatform",
    fieldLabel: "Vendor Connection",
    fieldValue: "VDF Platform",
    fieldType: "select",
    required: false,
    validateType: "custom",
    toolTipId: "toolTipVdfPlatform",
    toolTipText: "Specify the connection platform used by Vendor.",
    option: [
      {
        optionName: "Commerce Hub",
        optionValue: "chub",
      },
      {
        optionName: "Direct EDI",
        optionValue: "directEdi",
      },
      {
        optionName: "Direct EDI RDS",
        optionValue: "directEdiRDS",
      },
      {
        optionName: "Macys-Mirakl",
        optionValue: "mcymirakl",
      },
      {
        optionName: "Bloomies-Mirakl",
        optionValue: "blmmirakl",
      },
    ],
  },
  {
    fieldId: "salesProjections",
    fieldLabel: "Annual Sales Volume ($)",
    required: false,
    fieldType: "USDNumber",
    toolTipId: "toolTipAnnualSales",
    validateType: "custom",
    toolTipText: "New vendors annual sales volume in USD.",
    maxLength: 15,
  },
  {
    fieldId: "productType",
    fieldLabel: "Product Type",
    required: false,
    fieldType: "text",
    toolTipId: "toolTipProductType",
    maxLength: 30,
    validateType: "custom",
    toolTipText: "Vendor product type.Max 30 characters allowed",
  },
  {
    fieldId: "frieghtType",
    fieldLabel: "Freight Type",
    required: false,
    fieldType: "select",
    option: [
      {
        optionName: "Pre-paid",
        optionValue: "Pre-paid",
      },
      {
        optionName: "Pick & Pack",
        optionValue: "Pick & Pack",
      },
    ],
  },
];

export const returnDispositionOptions = [
  {
    label: "Salvage Agreement",
    value: "salAgrmnt",
  },
  {
    label: "Salvage Allowance",
    value: "salAllow",
  },
  {
    label: "Destroy",
    value: "destroy",
  },
  {
    label: "RTV",
    value: "RTV",
  },
  {
    label: "None",
    value: "none",
  },
];

export const marketPlaceFields = [
  {
    fieldId: "merchantCategoryCode",
    fieldLabel: "Merchant Category Code:",
    required: false,
    fieldType: "text",
    toolTipId: "toolTipMerchantCategoryCode",
    validateType: "custom",
    toolTipText: "Merchant Category Code",
  },
  {
    fieldId: "returnLessRefundOptIn",
    fieldLabel: "ReturnLess Refunds:",
    required: false,
    fieldType: "text",
    toolTipId: "toolTipReturnLessRefundOptIn",
    validateType: "custom",
    toolTipText: "ReturnLess Refunds",
  },
  {
    fieldId: "dRaasSignatureRequiredForReturns",
    fieldLabel: "Signature Required Returns:",
    required: false,
    fieldType: "text",
    toolTipId: "toolTipSignatureRequiredForReturns",
    validateType: "custom",
    toolTipText: "Signature Required Returns",
  },
  {
    fieldId: "isInternationalSeller",
    fieldLabel: "International Seller:",
    required: false,
    fieldType: "text",
    toolTipId: "toolTipIsInternationalSeller",
    validateType: "custom",
    toolTipText: "International Seller",
  },
  {
    fieldId: "deliveryRaasOptIn",
    fieldLabel: "Shipping Rate as a Service:",
    required: false,
    fieldType: "text",
    toolTipId: "toolTipDeliveryRaasOptIn",
    validateType: "custom",
    toolTipText: "Shipping Rate as a Service",
  },
];

export const ConsignmentBloomingdales = [
  {
    fieldId: "firstReceiptDate",
    fieldLabel: "First Receipt Date",
    fieldType: "date",
    placeHolder: "mm/dd/yyyy",
    length: "2",
    toolTipId: "toolTipFirstReceiptDate",
    required: false,
    toolTipText: "Select First Receipt Date.",
  },
  {
    fieldId: "endOfProgramDate",
    fieldLabel: "End of Program Date",
    fieldType: "date",
    placeHolder: "mm/dd/yyyy",
    length: "2",
    toolTipId: "toolTipEndOfProgramDate",
    required: false,
    toolTipText: "Select End of Program Date.",
  },
  {
    fieldId: "anticipatedAverageStock",
    fieldLabel: "Anticipated Average Stock",
    required: false,
    fieldType: "USDNumber",
    toolTipId: "toolTipAnticipatedAverageStock",
    validateType: "custom",
    toolTipText: "New vendors Anticipated Average Stock in USD.",
    maxLength: 15,
  },
  {
    fieldId: "storeLocationsInvolved",
    fieldLabel: "Store Locations Involved",
    fieldType: "searchSelect",
    required: false,
    validateType: "custom",
    multiSelect: true,
    toolTipId: "toolTipStoreLocationsInvolved",
    toolTipText: "Specify the Store Locations Involved by Vendor.",
  },
];

export default MerchantApprovalFields;
